<div id="lista" class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
<div class="header accent"
fxLayout="column" fxLayoutAlign="center center"
fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

<!-- TÍTULO E BOTÕES -->
<div fxLayout="row" fxLayoutAlign="start center" fxFlex="nogrow">
   <!-- APP TITLE -->
   <div class="logo"
        fxLayout="row" fxLayoutAlign="start center">
       <mat-icon class="logo-icon s-32 mr-16">
           business
       </mat-icon>
       <span class="logo-text h1">
           Característica do COE
       </span>
       
       <!-- BOTÕES DE AÇÃO -->
       <div fxLayout="row" fxLayoutAlign="start center" style="margin-left: 16px; gap: 8px;">
           <!-- BOTÃO CONSULTAR -->
           <button mat-mini-fab 
                   color="accent"
                   matTooltip="Consultar"
                   (click)="openFiltro()">
               <mat-icon>search</mat-icon>
           </button>
           
           <!-- BOTÃO NOVA CARACTERÍSTICA -->
           <button mat-mini-fab 
                   color="accent"
                   matTooltip="Nova Característica"
                   (click)="openCadastro()">
               <mat-icon>add</mat-icon>
           </button>
           
           <!-- BOTÃO IMPORTAR (condicional) -->
           <button *ngIf="user.role_id == 4 || user.role_id == 7 || user.role_id == 2 || user.role_id == 9"
                   mat-mini-fab 
                   color="accent"
                   matTooltip="Importar Arquivo"
                   (click)="openUpload()">
               <mat-icon>cloud_upload</mat-icon>
           </button>
       </div>
   </div>
</div>
</div>

        <!-- CONTENT CARD -->
        <div class="content-card">
            <ngx-datatable 
                #table 
                class='material' 
                [loadingIndicator]="loadingIndicator"
                [columns]="columns" 
                [columnMode]="'force'" 
                [headerHeight]="50"                       
                [footerHeight]="50" 
                [rowHeight]="'auto'" 
                [rows]='rows'>

                <ngx-datatable-column name="Cód. Cetip" prop="codigo_cetip" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-codigo_cetip="value" ngx-datatable-cell-template>
                        {{ codigo_cetip }}
                    </ng-template>
                </ngx-datatable-column>            

                <ngx-datatable-column name="Nome" prop="nome" [sortable]="false" [width]="400">
                    <ng-template let-rowIndex="rowIndex" let-nome="value" ngx-datatable-cell-template>
                        {{ nome }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Rent. Atual" prop="rent_atual" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-rent_atual="value" ngx-datatable-cell-template>
                        {{ rent_atual | number : '1.2-2' }} {{ rent_atual != '' ? '%' : ''}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="ROA (%)" prop="vlr_roa" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-vlr_roa="value" ngx-datatable-cell-template>
                        {{ vlr_roa | number : '1.0-0' }} {{ vlr_roa != '' ? '%' : ''}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Data de Inicio Reservar" prop="data_inicio" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-data_inicio="value" ngx-datatable-cell-template>
                        {{ data_inicio | date:'dd/MM/yyyy' }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Data de Fim da Reserva" prop="data_fim" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-data_fim="value" ngx-datatable-cell-template>
                        {{ data_fim | date:'dd/MM/yyyy' }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Ação" prop="id" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-id="value" ngx-datatable-cell-template>
                        <button mat-icon-button matTooltip="Alterar Ação" (click)="openAlterar(id)">
                            <mat-icon aria-label="Editar Ação">edit</mat-icon>
                        </button>

                        <button mat-icon-button color="warn" matTooltip="Excluir Ação" (click)="delete(id)">
                            <mat-icon aria-label="Excluir Ação">delete</mat-icon>
                        </button>
                    </ng-template>
                </ngx-datatable-column>

            </ngx-datatable>

            <div style="padding: 5px 10px">
                <mat-paginator 
                    #paginator 
                    [length]="length"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent($event)">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>